import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export interface DashboardStat {
  label: string;
  value: string;
  trend: string;
  color: string;
  bg: string;
  icon: string;
}

export interface ChartData {
  label: string;
  value: number;
}

export interface UpcomingAppointment {
  patientName: string;
  time: string;
  date: string;
  procedure: string;
  status: string;
}

export interface DashboardData {
  stats: DashboardStat[];
  chartData: ChartData[];
  upcomingAppointments: UpcomingAppointment[];
  revenueByCategory: ChartData[];
  patientGrowth: ChartData[];
}

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/statistics`;

  getDashboardStats(startDate?: string, endDate?: string) {
    const params: any = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    
    return this.http.get<DashboardData>(`${this.apiUrl}/dashboard`, { params });
  }

  getSystemDashboardStats() {
    return this.http.get<any>(`${this.apiUrl}/system/dashboard`);
  }
}
